import relatorioGeralSaidaPaciente from './relatorioGeralSaidaPacienteRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorios`

    return {
        relatorioGeralSaidaPaciente: relatorioGeralSaidaPaciente(baseUrl),
    }
}
